import { WorkspaceFilterViewModel } from "Services/API/API";

export function getWorkspaceFilterViewModel(): WorkspaceFilterViewModel | undefined {
   const urlParams = new URLSearchParams(window.location.search);

   return new WorkspaceFilterViewModel({
      amenities: urlParams["amenities"],
      reservationLengthMinutes: urlParams["reservationLengthMinutes"],
      reservationMethod: urlParams["reservationMethod"],
      reservationStart: urlParams["reservationStart"],
      spaceTypes: urlParams["spaceTypes"],
      startTime: urlParams["startTime"],
      workspaceCapacity: urlParams["workspaceCapacity"]
   });
}
